import { LineItemApiCreateRequest } from 'shared/src/api/line-item-api-types';
import type { PacingValidatorUpdate } from 'shared/src/domain/line-item/pacing-validator';

export function toValidatorUpdate(u: LineItemApiCreateRequest): PacingValidatorUpdate {
  return {
    dates: u.dates,
    pacing_type: u.pacing_type,
    pacing_details: u.pacing_details,
    totalPaced: calcTotalPaced(u),
    priceFloor: u.line_item_type === 'standard' ? u.price : null
  };
}

function calcTotalPaced(u: LineItemApiCreateRequest): number {
  switch (u.line_item_type) {
    case 'standard':
      return u.price;
    case 'management_fee':
      return u.media_budget;
    case 'zero_dollar':
      return u.estimated_units * u.planned_unit_cost;
  }
}
